var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mail",
    clipPath: "url(#clip0_38_123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.2857 2.64062H0.714286C0.319196 2.64062 0 2.95982 0 3.35491V17.6406C0 18.0357 0.319196 18.3549 0.714286 18.3549H19.2857C19.6808 18.3549 20 18.0357 20 17.6406V3.35491C20 2.95982 19.6808 2.64062 19.2857 2.64062ZM18.3929 5.11384V16.7478H1.60714V5.11384L0.991071 4.63393L1.8683 3.5067L2.82366 4.25H17.1786L18.1339 3.5067L19.0112 4.63393L18.3929 5.11384ZM17.1786 4.24777L10 9.82813L2.82143 4.24777L1.86607 3.50446L0.988839 4.6317L1.60491 5.11161L9.22991 11.0402C9.44919 11.2105 9.71897 11.303 9.99665 11.303C10.2743 11.303 10.5441 11.2105 10.7634 11.0402L18.3929 5.11384L19.0089 4.63393L18.1317 3.5067L17.1786 4.24777Z",
    fill: "#3D3D3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.e2221565146fed1cfb5dabb85b89aa7a.svg";
export { ForwardRef as ReactComponent };